import React , { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login.js';
 
import Sidebar from './pages/Sidebar.js';
import Header from './pages/Header.js';
 
import ExecutiveDashboard from './pages/ExecutiveDashboard.js';
import ProjectDashboard from './pages/ProjectDashboard.js';
import ResourceDashboard  from './pages/ResourceDashboard.js';
import Rak  from './pages/Rak.js';
import TreeView  from './pages/TreeView.js';
import ListPO  from './pages/ListPO.js';
import ListPOEng  from './pages/ListPOEng.js';
import TaskList  from './pages/TaskList.js';
import InvoiceList  from './pages/InvoiceList.js';
import InvoiceListV2  from './pages/InvoiceListV2.js';
import InvoiceListV3  from './pages/InvoiceListV3.js';
import AddInvoice  from './pages/AddInvoice.js';
import AddInvoiceV2  from './pages/AddInvoiceV2.js';
import AddInvoiceV3 from './pages/AddInvoiceV3.js';
import PO  from './pages/PO.js';
import AxiosFetchData  from './pages/AxiosFetchData.js';

import 'react-datepicker/dist/react-datepicker.css';
import "./assets/dashboard/bootstrap/css/bootstrap.min.css"
//import "./assets/dashboard/dist/css/AdminLTE.min.css"
import "./assets/dashboard/dist/css/skins/_all-skins.min.css"
import 'font-awesome/css/font-awesome.min.css';
import EditInvoice from './pages/EditInvoice.js';
import EditInvoiceV2 from './pages/EditInvoiceV2.js';
import StatusList from './pages/StatusList.js';
import UserList from './pages/UserList.js';
 
import Empty from './pages/Empty.js';
import AddPO from './pages/AddPO.js';
import Material from './pages/Material.js';
import MaterialDetail from './pages/MaterialDetail.js';
import RakApproval from './pages/RakApproval.js';
import NOTFOUND from './pages/NOTFOUND.js';
import RolesPolicies from './pages/RolesPolicies.js';
import LiveStock from './pages/LiveStock.js';
import PageUnderConstruction from './pages/PageUnderConstruction.js';
import EditInvoiceV3 from './pages/EditInvoiceV3.js';
import EditInvoiceRetention from './pages/EditInvoiceRetention.js';
import Chat from './pages/Chat.js';
import PaymentList from './pages/PaymentList.js'
import DynamicPage from './pages/DynamicPage.js'
import DailyJournal from './pages/DailyJournal.js'
import ListPOCompleted from './pages/ListPOCompleted.js'
import RequestMaterialApproval from './pages/RequestMaterialApproval.js';
import RequestMaterial from './pages/RequestMaterial.js';
import RequestMaterialAdd from './pages/RequestMaterialAdd.js';
import RequestMaterialEdit from './pages/RequestMaterialEdit.js';
import DailyJournalV2 from './pages/DailyJournalV2.js';
import ListPOV2 from './pages/ListPOV2.js';
//import { requestFCMToken,messaging } from './utils/firebase.js';
import {onMessage} from "firebase/messaging"
import ResponseDialog from './components/ResponseDialog.js';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from './pages/UrlParam.js';
import jwtDecode from 'jwt-decode';
import Mom from './pages/Mom.js'
function App() {
  const [role, setRole] = useState('');
  const [message, setmessage] = useState('');
 

  useEffect(() => {
    // const fetchFCMToken = async () =>{
    //     try{
        
    //          onMessage(messaging, (payload) => {
    //                     console.log('Message received in foreground:', payload);
    //                     // Display notification or update UI
    //                     new Notification(payload.notification.title, {
    //                         body: payload.notification.body,
    //                         icon: payload.notification.icon
    //                     });
    //                     setmessage(payload.notification.title + "," + payload.notification.body)
    //                     //alert(payload.notification.body)
    //                 });
    //     }catch(err){
    //         console.error("Error getting  FCM token :", err)
    //     }
    // }
   
    //fetchFCMToken()
 }, []);
 

  return (
    <div>
     
      <Router>
      <ResponseDialog message={message} setmessage={setmessage}></ResponseDialog>
        <Routes>
        <Route path="/Empty" element={<Empty />} />
          <Route path="/" element={<Login />} />
        
          <Route path="/Sidebar" element={<Sidebar />} />
          <Route path="/Header" element={<Header />} />
        
      
          <Route path="/ExecutiveDashboard" element={<ExecutiveDashboard />} />
          <Route path="/ProjectDashboard" element={<ProjectDashboard />} />
          <Route path="/ResourceDashboard" element={<ResourceDashboard />} />

      
          <Route path="/Rak/:id" element={<Rak />} />
          <Route path="/TreeView/:id" element={<TreeView />} />
          <Route path="/ListPO" element={<ListPO />} />
          <Route path="/ListPOEng" element={<ListPOEng />} />
          <Route path="/TaskList/:id" element={<TaskList />} />
          {/* <Route path="/InvoiceList/:id" element={<InvoiceList />} /> */}
          <Route path="/InvoiceListV2/:id" element={<InvoiceListV2 />} />
          <Route path="/InvoiceListV3/:id" element={<InvoiceListV3 />} />
          <Route path="/AddInvoice/:id" element={<AddInvoice />} />
          <Route path="/EditInvoice/:id" element={<EditInvoice />} />
          <Route path="/EditInvoiceV3/:id/:id2" element={<EditInvoiceV3 />} />
          <Route path="/AddInvoiceV2/:id" element={<AddInvoiceV2 />} />
          <Route path="/AddInvoiceV3/:id/:id2" element={<AddInvoiceV3 />} />
          
             
              <Route path="/InvoiceList/:id" element={<InvoiceList />} />  
             {/* <Route path="/InvoiceList/:id" element={<PageUnderConstruction />} /> */}
             
             <Route path="/AddInvoice/:id" element={<AddInvoice />} />
             <Route path="/EditInvoice/:id" element={<EditInvoice />} />
             <Route path="/EditInvoiceV2/:id" element={<EditInvoiceV2 />} />
              <Route path="/ListPOV2" element={<ListPOV2 />} />
            
           
             <Route path="/StatusList" element={<StatusList />} />
             <Route path="/UserList" element={<UserList />} />
        
             <Route path="/PO/:id" element={<PO />} />
             {/* <Route path="/AddPO/:id/:id2/:id3?" element={<AddPO />} /> */}
             <Route path="/AddPO/:id/:id2/:id3?/:id4" element={<AddPO />} />
             <Route path="/Material/:id" element={<Material />} />
             <Route path="/MaterialDetail/:id/:id2" element={<MaterialDetail />} />
             <Route path="/RakApproval" element={<RakApproval />} />
             <Route path="/NOTFOUND" element={<NOTFOUND />} />
             <Route path="/LiveStock" element={<LiveStock />} />
             <Route path="/RolesPolicies" element={<RolesPolicies />} />
             <Route path="/EditInvoiceRetention/:id/:id2" element={<EditInvoiceRetention />} />
             <Route path="/Chat/:id?" element={<Chat />} />
             <Route path="/Payment" element={<PaymentList />} />
              <Route path="/DynamicPage" element={<DynamicPage />} />
              <Route path="/DailyJournal" element={<DailyJournal />} />
               <Route path="/DailyJournalV2" element={<DailyJournalV2 />} />
               <Route path="/ListPOCompleted" element={<ListPOCompleted />} />
              <Route path='/RequestMaterialApproval' element={<RequestMaterialApproval />} />
              <Route path='/RequestMaterial/:id' element={<RequestMaterial />} />
              <Route path='/RequestMaterialAdd/:id' element={<RequestMaterialAdd />} />
              <Route path='/RequestMaterialEdit/:id/:id2' element={<RequestMaterialEdit />} />
              <Route path='/Mom/:id?' element={<Mom />} />
              
        </Routes>
        

      {/* {role != "PM" && (
           <Routes>
            <Route path="/ExecutiveDashboard" element={<ExecutiveDashboard />} />
             <Route path="/Sidebar" element={<Sidebar />} />
             <Route path="/Header" element={<Header />} />
             <Route path="/" element={<Login />} />
             <Route path="/Rak/:id" element={<Rak />} />
             <Route path="/ListPOEng" element={<ListPOEng />} />
             <Route path="/TaskList/:id" element={<TaskList />} />
             <Route path="/InvoiceList/:id" element={<InvoiceList />} />
             <Route path="/AddInvoice/:id" element={<AddInvoice />} />
             <Route path="/EditInvoice/:id" element={<EditInvoice />} />
           </Routes>

      )} */}
      </Router>
    </div>
  );
}

export default App;
